<template lang="pug">
    .rsl-user-menu
        ul.rsl-user-menu__list
            li.rsl-user-menu__item
                span.rsl-user-menu__link.rsl-user-menu__link_name {{ userName }}
            li.rsl-user-menu__item(
            v-for='(link, index) in infoLinks'
            v-bind:key="'menuItem' + index"
            )
                a.rsl-user-menu__link(
                v-bind:href='link.href'
                target='_blank'
                ) {{ link.title }}
            li.rsl-user-menu__item
                form.rsl-user-menu__form(
                name='Logout RSL'
                v-on:click="logoutUser"
                )
                    button.rsl-user-menu__link(type='submit') Выйти

</template>

<script>

    import axios from 'axios';

    export default {
        props: {
            /**
             * Массив объектов, с ссылками и их названиями, которые передаются для ссылок в меню пользователя
             * Объект выглядит следующим образом:
             * @param {String} href - Ссылка для тега <a>
             * @param {String} title - Лейбл для ссылки
             * @type {Array}
             */
            infoLinks: {
                type: Array,
                required: false,
                default() {
                    return [
                        {
                            href: 'https://passport.rsl.ru/profile',
                            title: 'Профиль'
                        },
                        {
                            href: 'https://passport.rsl.ru/profile/index?tab=services',
                            title: 'Услуги'
                        },
                        {
                            href: 'http://favorites.rsl.ru/ru',
                            title: 'Избранное'
                        }
                    ];
                }
            },
            /**
             * Ссылка которую мы передаем в action формы для выхода из системы
             * @type {String}
             */
            logoutLink: {
                type: String,
                required: false,
                default: 'http://localhost:8080/logout'
            },
            /**
             * Имя Пользователя
             * @type {String}
             */
            userName: {
                type: String,
                required: false,
                default: 'Test User'
            }
        },
        methods: {
            logoutUser() {
                axios.post(`${this.logoutLink}`).then(response => {
                    this.$router.push({
                        name: "Enter",
                        params: {
                            ...this.$route.params
                        },
                        query: {
                            ...this.$route.query
                        }
                    })
                });
            }
        }
    };
</script>

<style lang="sass" src="./rsl-user-menu.sass"></style>
